import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const MartialArts = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my martial arts business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps martial arts businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for martial arts businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most martial arts businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my martial arts business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like martial arts. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Martial Arts - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Martial Arts CRM", url: "/industries/martial-arts" }
  ];

  const industryData = {
    name: 'Martial Arts School',
    title: 'Keep Students Engaged & Grow to Black Belt Level',
    subtitle: 'Automate belt testing reminders, reduce dropouts, and build a thriving school community',
    icon: '🥋',
    challenges: [
      'Students drop out before black belt',
      'Parents forget about belt testing',
      'Hard to get trial students to enroll',
      'Class scheduling is complicated',
      'Difficult to build community engagement'
    ],
    solutions: [
      'Belt progression tracking and reminders',
      'Student retention campaigns',
      'Trial to enrollment automation',
      'Class schedule management',
      'Community engagement automation'
    ],
    features: [
      'Student CRM with belt tracking',
      'Belt testing reminders',
      'Attendance monitoring',
      'Trial class follow-up',
      'Parent communication automation',
      'Tournament registration',
      'Membership management',
      'Review requests'
    ],
    results: [
      '65% retention to black belt',
      '80% trial conversion rate',
      '50% more student enrollment',
      '5.6K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Martial Arts UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for martial arts businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for martial arts UK, martial arts business software, martial arts customer management, martial arts lead generation UK"
        url="/industries/martial-arts"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default MartialArts;